import { Link } from "react-router-dom";
import { useSkin } from "@/lib/skin";

export default function Logo({ className = "", testId = "logo" }) {
  const dark = useSkin() === "dark";
  return (
    <Link to="/" data-testid={testId} className={`inline-flex items-center gap-2 group ${className}`}>
      <div className="relative">
        <svg width="34" height="34" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <rect width="40" height="40" rx={dark ? "0" : "9"} fill={dark ? "#F2F2F0" : "#0052FF"}/>
          <path d="M9 24c0-1.4 1.1-2.5 2.5-2.5h17c1.4 0 2.5 1.1 2.5 2.5v2.5c0 .6-.4 1-1 1H10c-.6 0-1-.4-1-1V24z" fill={dark ? "#0A0A0B" : "white"}/>
          <path d="M12 21.5l2.2-5.4c.3-.7 1-1.1 1.7-1.1h8.2c.7 0 1.4.4 1.7 1.1l2.2 5.4H12z" fill={dark ? "#0A0A0B" : "white"} opacity=".85"/>
          <circle cx="14" cy="28" r="1.8" fill={dark ? "#F2F2F0" : "#0F172A"}/>
          <circle cx="26" cy="28" r="1.8" fill={dark ? "#F2F2F0" : "#0F172A"}/>
        </svg>
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-display text-[20px] font-extrabold tracking-tight ${dark ? "text-[#F2F2F0]" : "text-slate-900"}`} data-testid="logo-wordmark">
          Carfornia <span className={dark ? "text-slate-400" : "text-brand-blue"}>Buyers</span>
        </span>
        <span className="text-[10px] uppercase tracking-[0.18em] text-slate-500 font-bold -mt-0.5">
          Hayward, California
        </span>
      </div>
    </Link>
  );
}
